// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBN8f7IpsxiCue1Q5ts4sEbbV7k4CTqSVc",
    authDomain: "auxswot-spel.firebaseapp.com",
    databaseURL: "https://auxswot-spel.firebaseio.com",
    projectId: "auxswot-spel",
    storageBucket: "auxswot-spel.appspot.com",
    messagingSenderId: "1014592529642",
    appId: "1:1014592529642:web:2706aa5aee5cbcf519a393",
    measurementId: "G-YSPLBDRDFY"

    // apiKey: "AIzaSyAA1TFZ3qRpPaC7xAAM5_DwTDXF-503DV4",
    // authDomain: "swiftnews-9bfec.firebaseapp.com",
    // databaseURL: "https://swiftnews-9bfec.firebaseio.com",
    // projectId: "swiftnews-9bfec",
    // storageBucket: "swiftnews-9bfec.appspot.com",
    // messagingSenderId: "471804960868",
    // appId: "1:471804960868:web:991e21ef189a1646aabf71",
    // measurementId: "G-HWJ30SQM0W"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
